import React, { FC, useEffect, useState } from 'react'
import Modal from '../common/Modal'
import { fetchTaskLabelGroupCategoryLabelGroup } from '../../../states/containers/task/taskSlice'
import { useDispatch } from 'react-redux'
import LoadingSquare from '../common/LoadingSquare'

interface LabelGroupCategory {
  id: number
  category_name: string
  color: string
}

interface LabelGroup {
  id: number
  name: string
  code: string | null
  color: string
}

interface Props {
  isDisplay: boolean
  labelGroupCategory: LabelGroupCategory | undefined
  closeCallback: VoidFunction
}

const ViewLabelGroupModal: FC<Props> = (props) => {
  const {
    isDisplay,
    labelGroupCategory,
    closeCallback,
  } = props

  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [labelGroupList, setLabelGroupList] = useState<LabelGroup[]>([])

  const fetchData = () => {
    setIsLoading(true)
    dispatch(
      fetchTaskLabelGroupCategoryLabelGroup(
        {
          label_group_category_id: labelGroupCategory?.id.toString(),
          search_type: "assigned",
          limit: 1000,
        },
        (result) => {
          setLabelGroupList(result.label_groups)
          setIsLoading(false)
        },
      ),
    )
  }

  const closeModal = () => {
    closeCallback()
  }

  useEffect(() => {
    if (!isDisplay) return
    fetchData()
  }, [isDisplay])

  return (
    <Modal
      show={isDisplay}
      wrapperClass="approver_setting_modal"
      closeCallback={closeModal}
      closeable
    >
      <>
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            gap: "2px",
            marginBottom: "16px",
          }}
        >
          カテゴリー：
          <div
            style={{
              fontSize: "16px",
            }}
          >
            {labelGroupCategory?.category_name}
          </div>
          に設定されているプロジェクト
        </div>
        <div
          style={{
            border: "solid 1px #CCCCCC",
            borderRadius: "4px",
            padding: "8px",
            display: "flex",
            flexFlow: "column",
            gap: "4px",
            maxHeight: "300px",
            overflowY: "scroll",
          }}
        >
          {
            isLoading ? (
              <LoadingSquare>
                <>
                  プロジェクトデータを取得しています…
                </>
              </LoadingSquare>
            ) : (
              <>
                {
                  labelGroupList.map((v) => (
                    <div
                      style={{
                        borderBottom: "dashed 1px #999999",
                        padding: "4px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <div
                        style={{
                          width: "12px",
                          height: "12px",
                          backgroundColor: v.color,
                        }}
                      />
                      {v.name}
                      {v.code && `(${v.code})`}
                    </div>
                  ))
                }
                {
                  !labelGroupList.length && (
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "#999999",
                      }}
                    >
                      設定されているプロジェクトは0件です
                    </div>
                  )
                }
              </>
            )
          }
        </div>
      </>
    </Modal>
  )
}

export default ViewLabelGroupModal
